<template>
  <div class="goods-ztorder">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入订单编号或提货码..." />
      </FormItem>
      <FormItem>
        <Input v-model="formItem.pay_order_num"
               placeholder="输入支付单号..."
               style="width: 260px;" />
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_status"
                clearable
                filterable
                placeholder="支付状态...">
          <Option v-for="item in payStatusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_name"
                clearable
                filterable
                placeholder="收单机构">
          <Option v-for="item in payNameList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border
           max-height="600"
           :columns="list"
           :data="tablelist"
           :loading="dataloading"
           class="B2CList"></Table>
    <!-- 详情弹层 start-->
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <Row>
        <Col :xs="24"
             :md="24">
        <div v-model="detaildata">
          <div>
            <span class="key_name">支付单号:</span>
            <span>{{detaildata.pay_order_num}}</span>
          </div>
          <div>
            <span class="key_name">支付方式:</span>
            <span>{{detaildata.pay_name}}</span>
          </div>
          <div>
            <span class="key_name">订单编号:</span>
            <span>{{detaildata.order_num}}</span>
          </div>
          <div>
            <span class="key_name">收件人:</span>
            <span>{{detaildata.person}}</span>
          </div>
          <div>
            <span class="key_name">收件电话:</span>
            <span>{{detaildata.phone}}</span>
          </div>
          <div>
            <span class="key_name">收件地址:</span>
            <span>{{detaildata.address}}</span>
          </div>
          <div>
            <span class="key_name">快递名称:</span>
            <span>{{detaildata.logistics_name}}</span>
          </div>
          <div>
            <span class="key_name">快递编号:</span>
            <span>{{detaildata.logistics_code}}</span>
          </div>
          <div v-if="wxreturnmoney_method">
            <span class="key_name">融宝返回:</span>
            <span>{{detaildata.wxreturn_status}}</span>
          </div>
          <div v-if="wxreturnmoney_status">
            <span class="key_name">融宝退款返回:</span>
            <span>{{detaildata.wxreturnmoney_status}}</span>
          </div>
        </div>
        </Col>
        <Col :xs="24"
             :md="24">
        <Table border
               stripe
               :columns="columsgood"
               :data="datagood"></Table>
        </Col>
      </Row>
    </Drawer>
    <!-- 详情弹层 end -->
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
import expandRow from "./table-expand";

export default {
  name: "goods-ztorder",
  data () {
    return {
      modal1: false, // 订单规格弹层显示状态
      dataloading: true,
      detaildata: [],
      selectLogistics: [],
      wxreturnmoney_status: false,
      wxreturnmoney_method: false,
      payNameList: [
        { id: 0, name: "融宝" },
        { id: 1, name: "财付通" },],
      payStatusList: [
        { id: 0, name: "未支付" },
        { id: 1, name: "支付中" },
        { id: 2, name: "已完成" }
      ],
      formItem: {
        key: "",
        pay_name: "",
      },
      shipdata: {
        status: "1"
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        // {
        //     type: 'expand',
        //     render: (h, params) => {
        //         return h(ordergood, {
        //             props: {
        //                 row: params.row
        //             }
        //         })
        //     }
        // },
        {
          title: "",
          type: "expand",
          width: 30,
          // fixed:"left",
          // expand: true,
          render: (h, params) => {
            let that = this;
            return h(expandRow, {
              props: {
                // _expanded:true,
                row: params.row.ordergood,
                showViewerFun: () => {
                  let imgs = [];
                  console.log(params.row.ordergood);
                  for (var i in params.row.ordergood) {
                    imgs.push(params.row.ordergood[i].good_thumb);
                  }
                  that.viewerImages = imgs;
                  console.log(that.viewerImages);
                  that.$viewer.show();
                }
              }
            });
          }
        },
        {
          title: "订单编号",
          align: "center",
          key: "order_num",
          minWidth: 185
          // fixed:"left"
        },
        {
          title: "支付单号",
          align: "center",
          key: "pay_order_num",
          minWidth: 185
        },
        {
          title: "提货码",
          minWidth: 100,
          align: "center",
          key: "tihuocode"
        },

        {
          title: "会员名",
          minWidth: 140,
          align: "center",
          key: "username"
        },
        {
          title: "商品价格",
          minWidth: 100,
          align: "center",
          key: "old_prices"
        },
        {
          title: "折扣",
          minWidth: 100,
          align: "center",
          key: "discount"
        },
        {
          title: "商品折后价",
          minWidth: 100,
          align: "center",
          key: "real_prices"
        },
        {
          title: "实付款（元）",
          minWidth: 100,
          align: "center",
          key: "total_price"
        },
        {
          title: "支付方式",
          minWidth: 100,
          align: "center",
          key: "pay_name"
        },
        {
          title: "订单状态",
          minWidth: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            // return h('div', params.row.status == "0" ? '关闭' : (params.row.status == "1" ? '正常':"完成"))
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.status == "0"
                      ? "success"
                      : params.row.status == "1"
                        ? "green" // orange
                        : "red" // geekblue
                }
              },
              params.row.status == "0"
                ? "关闭"
                : params.row.status == "1"
                  ? "正常"
                  : params.row.status == "3"
                    ? "退款中"
                    : "完成"
            );
          }
        },
        {
          title: "支付状态",
          minWidth: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.pay_status == "0"
                ? "未支付"
                : params.row.pay_status == "1"
                  ? "支付中"
                  : "已完成"
            );
          }
        },
        // {
        //     title: '发货状态',
        //     minWidth: 100,
        //     align: "center",
        //     key: 'ship_status',
        //     render: (h, params) => {
        //             // return h('div', params.row.ship_status == "1" ? '已发货' : '未发货')
        //         return h('tag',
        //             {
        //                 props: {
        //                     color: params.row.ship_status == "1" ?'geekblue':'red',
        //                 }
        //             },
        //             params.row.ship_status == "1" ? '已发货' : '未发货')
        //         }
        // },
        // {
        //     title: '收货状态',
        //     minWidth: 100,
        //     align: "center",
        //     key: 'receipt_status',
        //     render: (h, params) => {
        //             // return h('div', params.row.receipt_status == "1" ? '已收货' : '未收货')
        //         return h('tag',
        //             {
        //                 props: {
        //                     color: params.row.receipt_status == "1" ?'geekblue':'red',
        //                 }
        //             },
        //             params.row.receipt_status == "1" ? '已发货' : '未发货')
        //         }
        // },

        // {
        //     title: '邮寄方式',
        //     minWidth: 100,
        //     align: "center",
        //     key: 'fare_type',
        //     render: (h, params) => {
        //             // return h('div', params.row.fare_type == "1" ? '自提' : '邮寄')
        //         return h('tag',
        //             {
        //                 props: {
        //                     color: params.row.fare_type == "1" ?'geekblue':'red',
        //                 }
        //             },
        //             params.row.fare_type == "1" ? '自提' : '邮寄')
        //         }
        // },
        // {
        //     title: '邮费',
        //     minWidth: 70,
        //     align: "center",
        //     key: 'fare',
        // },
        {
          title: "下单时间",
          minWidth: 150,
          align: "center",
          key: "created_at"
          // fixed:'right'
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 150,
          // fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == "1" &&
                        params.row.pay_status == "2" &&
                        params.row.ship_status == "1" &&
                        params.row.receipt_status == "0"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.ship(params.row.id);
                    }
                  }
                },
                "提货"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == "1" &&
                        params.row.receipt_status == "0"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.close(params.row.id);
                    }
                  }
                },
                "关闭"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      //订单详情
      columsgood: [
        {
          title: "产品名称",
          key: "good_title",
          width: 200,
          align: "center"
        },
        {
          title: "产品规格",
          width: 100,
          key: "good_spec_name",
          align: "center"
        },
        {
          title: "数量",
          width: 70,
          key: "nums",
          align: "center"
        },
        {
          title: "单价（元）",
          width: 120,
          key: "price",
          align: "center"
        },
        {
          title: "总价（元）",
          width: 120,
          key: "total_prices",
          align: "center"
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 80,
          render: (h, params) => {
            return h("div", params.row.status == 1 ? "退回" : "正常");
          }
        }
      ],
      datagood: [],
      viewerImages: [], // v-viewer图片列表
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      }
    };
  },
  // 计算
  computed: {},
  components: {
    expandRow
  },
  // 监听
  watch: {
    "$route.params": function (n, o) {
      if (n) {
        this.order_id = this.$route.params.id;
        // 取数据
        this.is_platprice = this.$route.params.is_platprice;
        // 取数据
        this.getTableList();
      }
    }
  },
  created: function () {
    this.order_id = this.$route.params.id;
    this.formItem.pay_status = this.$route.params.pay_status != -1 ? parseInt(this.$route.params.pay_status) : null;
    this.formItem.order_status = this.$route.params.order_status != -1 ? parseInt(this.$route.params.order_status) : null;

  },
  mounted: function () {
    this.is_platprice = this.$route.params.is_platprice;
    // 取数据
    this.getTableList();
  },
  updated: function () { },
  methods: {
    // 获取订单列表
    getTableList: function () {
      var params = {
        is_platprice: this.is_platprice,
        page: this.pages.current,
        size: this.pages.size,
        pay_status: this.formItem.pay_status,
        order_status: this.formItem.order_status,
      };
      this.$api.goodztorder.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          for (var i = 0; i < this.tablelist.length; i++) {
            this.tablelist[i]._expanded = true;
          }
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 查看详情
    detail: function (index) {
      this.modal1 = true;
      var params = {
        order_id: index
      };
      this.$api.goodorder.detail(params).then(res => {
        if (res.code == 200) {
          this.datagood = res.result.ordergood;
          this.detaildata.pay_order_num = res.result.pay_order_num;
          this.detaildata.order_num = res.result.order_num;
          this.detaildata.pay_name = res.result.pay_name;
          this.detaildata.person = res.result.person;
          this.detaildata.phone = res.result.phone;
          this.detaildata.address = res.result.address;
          this.detaildata.logistics_name = res.result.logistics_name;
          this.detaildata.logistics_code = res.result.logistics_code;
          this.detaildata.wxreturn_code = res.result.wxreturn_code;
          this.detaildata.wxreturn_msg = res.result.wxreturn_msg;
          this.detaildata.wxreturn_msg2 = res.result.wxreturn_msg2;
          this.detaildata.wxreturn_status = res.result.wxreturn_status;
          if (res.result.pay_method == 1) {
            this.wxreturnmoney_method = true;
          }
          if (res.result.pay_method == 1 && res.result.order_status == 3) {
            this.wxreturnmoney_status = true;
            this.detaildata.wxreturnmoney_status =
              res.result.wxreturnmoney_status;
          }
        }
      });
      return;
    },
    close: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goodorder.close({ order_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    perChange: function (index) {
      this.logistics_name = index.label;
    },
    ship: function (index) {
      this.$api.goodztorder.ship({ id: index }).then(res => {
        if (res.code == 200) {
          this.showCreatTypeModal = false;
          this.getTableList();
        }
      });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    // 筛选
    renderTable: function (name) {
      let params = {
        is_platprice: this.is_platprice,
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        pay_order_num: this.formItem.pay_order_num,
        pay_status: this.formItem.pay_status,
        order_status: this.formItem.order_status,
        pay_name: this.formItem.pay_name,
      };
      this.$api.goodztorder.list(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          for (var i = 0; i < this.tablelist.length; i++) {
            this.tablelist[i]._expanded = true;
          }
          this.$Message.success(res.msg);
        }
      });
    },
    // 获取viewer实例
    inited (viewer) {
      this.$viewer = viewer;
    }
  }
};
</script>
